module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia-qd.1583e2b6.png";